import React from "react";

const Header = () => {
  return (
    <React.Fragment>
      <div className="login-header">
        <div className="login-header-inner">
          <a className="login-header-logo" href="/login" aria-label="IPCS customer portal home">
            <img alt="IPCS" src="/assets/Img/logo.png" />
          </a>
          <div className="login-header-title">
            {/* <span>Customer Portal</span>
            <strong>
              Human Resources Onboarding and Contract Management System
            </strong> */}
          </div>
          <a className="login-header-support" href="mailto:Support@workfinity.com">
            <i className="fa fa-envelope-o" aria-hidden="true"></i>
            Support
          </a>
        </div>
      </div>

      <div className="login-welcome">
        <div className="login-welcome-content">
          <div className="login-welcome-brand">
            <span>Welcome to</span>
            <img alt="WorkFINITY" src="/assets/Img/logo_ft.png" />
          </div>
          <p>Human Resources Onboarding and Contract Management System</p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Header;
